import addMount from "../../../core/addMount";
import LoanList from "./loan-list.entry";

addMount({ appName: "loan-list", app: LoanList });
